import styled, { css } from 'styled-components';

export const ConfirmationStyled = styled.div`
  /* width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: var(--white);
  border-radius: 10px;
  padding: 30px;
  position: relative;
  box-shadow: 0px 4px 11px 0px #cccccc40;
  margin: 0 auto; */

  .task-completed {
    text-align: center;
    max-width: 350px;
    margin: 0 auto;

    .img-holder {
      width: 135px;
      height: 135px;
      margin: 0 auto 30px;

      img {
        display: block;
        max-width: 100%;
        height: 100%;
        margin: 0 auto;
      }
    }

    .text {
      display: block;
      margin-bottom: 15px;
    }
  }

  .title {
    display: block;
    font-size: 25px;
    line-height: 29px;
    font-weight: 500;
    color: var(--primary);
    margin-bottom: 16px;
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    max-width: 350px;
    width: 100%;
    margin: 0 auto;

    button {
      &:only-child {
        width: 100%;
        min-width: 100%;
      }
    }
  }

  .rename-campaign-form {
    width: 100%;
    max-width: 500px;
  }
`;
